import React, { useState, useEffect, useCallback } from 'react'
import defaultLogo from './department-logo.jpg'
import DepartmentInfoActions from './departmentInfoActions'

// Material-UI
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import './DepartmentInfo.scss'
import ChooseImage from '../../../Shared/ChooseImage'
import { FaRegCheckCircle } from 'react-icons/fa'
import LoadingSpinner from '../../../Shared/LoadingSpinner/LoadingSpinner'
import ButtonSave from '../../../Shared/ButtonSave/ButtonSave'
import { useErrorSnackBarContext } from '../../../Shared/ErrorSnackBar/ErrorSnackBarContext'
import Interceptor from '../../../../Services/serviceBase.interceptor'
import serviceBase from '../../../../Services/serviceBase'
import { useCMSContext } from './../../CMSContext'
import PaletteDropDown from '../../../Shared/PaletteDropDown/paletteDropDown'
import Palette from '../../../../Constants/palette'
import { IARDialog } from '../../../Shared/Dialog/IARDialog'
import QRCodeDialog from '../../../Shared/QRCodeDialog/QRCodeDialog'
import { BsFillQuestionCircleFill } from 'react-icons/bs'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'

function DepartmentInfo({ fireDepartment }) {
  const { errorSnackBarActions } = useErrorSnackBarContext()
  const [departmentInfoEntity, setDepartmentInfoEntity] = useState({
    fireDepartmentName: '',
    phrase: '',
    logo: '',
    dataPosted: false,
    postMessage: ''
  })
  const [showUsage, setShowUsage] = useState({
    myLSGuestUsers: 0,
    myLSRegisteredUsers: 0
  })
  const [departmentLogo, setDepartmentLogo] = useState([])
  const [images, setImages] = useState([]) // this images is the one to be send in post
  const [loading, setLoading] = useState(true)
  const [posting, setPosting] = useState(false)
  const [layout, setLayout] = useState()
  const [colors, setColors] = useState([])
  const [palette, setPalette] = useState()
  const [errorDepartmentName, setErrorDepartmentName] = useState('')
  const [dataPosted, setDataPosted] = useState({ posted: false, message: '' })
  const [dialog, setDialog] = useState({ open: false, qrCodeOpen: false })
  const [qrCodeImage, setQrCodeImage] = useState(null)
  const [sendQrImage, setSendQrImage] = useState(true)

  const {
    actions,
    state: { isReadOnlyMember }
  } = useCMSContext('')

  Interceptor.interceptor(errorSnackBarActions)

  useEffect(() => {
    if (qrCodeImage && sendQrImage) {
      sendDepartmentInfo(qrCodeImage)
    }
  }, [qrCodeImage])

  useEffect(() => {
    if (fireDepartment) {
      setDepartmentInfoEntity(fireDepartment)
      setLoading(false)
      async function fetchLayout() {
        const layoutData = await DepartmentInfoActions.getLayout(fireDepartment.identifier)
        if (layoutData.data && layoutData.data.LayoutSection) {
          setLayout(layoutData.data.LayoutSection)
        }
      }
      fetchLayout()
      //get showUsage info
      async function fetchShowUsage() {
        const showusageResponse = await DepartmentInfoActions.getShowUsage(
          fireDepartment.fireDepartmentId
        )
        if (showusageResponse?.status === 200) {
          setShowUsage(showusageResponse.data)
        }
      }
      fetchShowUsage()
      setDepartmentLogo([fireDepartment.logo])
    }
  }, [fireDepartment])

  useEffect(() => {
    if (layout) {
      const paletteArray = []
      if (layout.background) {
        layout.background.forEach((color) => {
          paletteArray.push(color)
        })
      }
      if (layout.flatColor) {
        paletteArray.push(layout.flatColor)
      }
      if (layout.sideBarColor) {
        layout.sideBarColor.forEach((color) => {
          paletteArray.push(color)
        })
      }
      setColors(paletteArray)
    }
  }, [layout])

  useEffect(() => {
    if (colors.length > 0) {
      const paletteValues = Object.values(Palette)
      const paletteObject = paletteValues.filter((a) => a.colors.includes(colors[0]))
      setPalette(paletteObject[0].id)
    }
  }, [colors])

  useEffect(() => {
    if (images.length > 0) {
      // update entity logo to update preview
      setDepartmentLogo([images[0].previewImage])
    }
  }, [images])

  const handleChange = (evt) => {
    const value = evt.target.value

    setDepartmentInfoEntity({
      ...departmentInfoEntity,
      [evt.target.name]: value
    })
  }

  const sendDepartmentInfo = (QRimage) => {
    setPosting(true)
    setDataPosted({ ...dataPosted, posted: false })

    let url = `${window._env_.COMMUNITY_API_URL}/fire-departments/info`

    const payload = {
      identifier: fireDepartment.identifier,
      name: departmentInfoEntity.fireDepartmentName,
      phrase: departmentInfoEntity.phrase,
      logo: images,
      paletteTheme: parseInt(palette)
    }
    const formData = new FormData()

    if (QRimage && QRimage instanceof Blob) {
      payload.qrCodeInfo = [
        {
          originalName: 'EntityQR.jpg',
          fireDepartmentIdentifier: fireDepartment.identifier
        }
      ]
      formData.append('QRcodeFile', QRimage, 'EntityQR.jpeg')
      setQrCodeImage(null)
    }

    formData.append('request', JSON.stringify(payload))
    formData.append('identifier', fireDepartment.identifier)

    images.forEach((image) => {
      if (image.file === undefined) return

      formData.append('images', image.file, image.originalName)
      image.file = null
    })

    serviceBase.post(url, formData).then(
      (response) => {
        setDepartmentInfoEntity({
          ...departmentInfoEntity,
          dataPosted: true,
          postMessage: 'Saved'
        })
        actions.setFireDepartment(response.data)
        setDataPosted({ posted: true, message: 'Saved' })
        setPosting(false)
        console.log('POST DepartmentInfo: ', response)
        setImages([])
      },
      (err) => {
        errorSnackBarActions.setOpen(true)
        setPosting(false)
        console.log(err)
      }
    )
  }

  const discardChanges = useCallback(() => {
    setDialog({ ...dialog, open: false })
    fireDepartment && setDepartmentInfoEntity(fireDepartment)
    setImages([])
    setDepartmentLogo([fireDepartment.logo])
    handleThemeChange(JSON.stringify(fireDepartment.paletteTheme))
  }, [fireDepartment])

  const cancelDialog = useCallback(() => {
    setDialog({ ...dialog, open: false })
  }, [])

  const handleThemeChange = useCallback(
    (event) => {
      setPalette(event)
    },
    [palette]
  )

  const openConfirmationDialog = useCallback(() => {
    setDialog({ ...dialog, open: true })
  }, [])

  const renderSavedMessage = useCallback(() => {
    if (dataPosted.posted) {
      return (
        <div className="save-message">
          <FaRegCheckCircle className="check-circle" />
          <span className="save-message-text">{dataPosted.message}</span>
        </div>
      )
    }
  }, [dataPosted])

  return (
    <div className="department-info">
      <IARDialog
        open={dialog.open}
        title="Confirm"
        content="Do you want to discard your changes?"
        onOk={discardChanges}
        onCancel={cancelDialog}
      />
      {fireDepartment && (
        <QRCodeDialog
          title="Entity's QR Code"
          open={dialog}
          handleClose={setDialog}
          qrcodeContent={fireDepartment.identifier}
          qrCodeUrl={fireDepartment.QRcodeURL}
          setQrCodeImage={setQrCodeImage}
          setSendQrImage={setSendQrImage}
        />
      )}
      <div className="page-header" id="entityPageHeader">
        <span id="entityInfoText">Entity Information</span>
      </div>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <Container maxWidth="lg">
          <Grid container spacing={2} direction={{ xs: 'column' }}>
            <Grid size={12}>
              <div className="page-description">
                This is the information that your community members will see when adding your entity
                to their MyLS app, and when accessing your entity in that app. Please upload your
                logo, and enter any applicable motto or tagline that you may use (optional). If the
                Entity name shown here is not what is commonly known in your community, click the
                applicable link to send the IaR team a message to change this.
              </div>
            </Grid>
            <Grid size={12} className="container">
              <div className="logo-info">
                {departmentLogo?.length ? (
                  <img src={departmentLogo} alt="Entity Logo" />
                ) : (
                  <img src={defaultLogo} alt="Entity Logo" />
                )}

                <ChooseImage
                  images={images}
                  setImages={setImages}
                  fireDepartmentIdentifier={departmentInfoEntity.identifier}
                  max={1}
                />
              </div>
            </Grid>
            <Grid size={12} className="container">
              <form noValidate autoComplete="off">
                <span htmlFor="">
                  Entity Code (this is the code members of the community can use in MyLS to search
                  for your MyLS system)
                </span>
                <div>
                  <div>
                    <span className="label">{departmentInfoEntity.identifier}</span>
                    <br />
                  </div>
                </div>

                {/*<Grid xs={12} className="container">
                  <a id="qrcode-a" onClick={() => setDialog({ ...dialog, qrCodeOpen: true })}>
                    Show entity's QR code
                  </a>
                    </Grid>*/}
                <Grid size={12} className="container">
                  <div className="entity-wrapper">
                    <label htmlFor="title" className="entity-name">
                      Entity's Name
                    </label>{' '}
                    <Tooltip
                      className="table-tooltip"
                      arrow
                      title={
                        <div
                          style={{
                            padding: '4px 10px',
                            fontSize: 14
                          }}
                        >
                          <React.Fragment>
                            <Typography>
                              The name that appears here and in your MyLS app can only be changed by
                              the IaR team. By default this initially is your on-screen name for
                              your IaR system but it can be changed to whatever name your community
                              best knows you as. To request a change to this name, please click here
                              to send an email to{' '}
                              <a href="mailto:MyLSNameChange@emergencysmc.com">
                                MyLSNameChange@emergencysmc.com
                              </a>{' '}
                              and include your current IaR agency log-in name, the name you want
                              your MyLS name changed to, and the specific reason for the requested
                              change. Please remember that MyLS systems are not allowed to be shared
                              between multiple agencies: it is one MyLS system per each IaR system.
                            </Typography>
                          </React.Fragment>
                        </div>
                      }
                    >
                      <span className="icon-wrapper">
                        <BsFillQuestionCircleFill className="entity-hint"></BsFillQuestionCircleFill>
                      </span>
                    </Tooltip>
                    <br />
                  </div>
                  <div>
                    {errorDepartmentName ? (
                      <>
                        <label htmlFor="error" className="error-text">
                          {errorDepartmentName}
                        </label>
                        <br />
                      </>
                    ) : (
                      <></>
                    )}
                    <div>
                      <label id="fireDepartmentName">
                        {departmentInfoEntity.fireDepartmentName}
                      </label>{' '}
                      <br />
                    </div>
                  </div>
                </Grid>
                <Grid size={12} className="container">
                  <span htmlFor="">MyLS Guest Users</span>
                  <div>
                    <div>
                      <span className="label">{showUsage.myLSGuestUsers}</span>
                      <br />
                    </div>
                  </div>
                </Grid>
                <Grid size={12} className="container">
                  <span htmlFor="">MyLS Registered Users</span>
                  <div>
                    <div>
                      <span className="label">{showUsage.myLSRegisteredUsers}</span>
                      <br />
                    </div>
                  </div>
                </Grid>
                <Grid size={12} className="container">
                  <span htmlFor="">Current search criteria</span>
                  <div>
                    <div>
                      <span className="label">
                        {`${departmentInfoEntity.city ? `${departmentInfoEntity.city}, ` : ''}${
                          departmentInfoEntity.county
                        }, ${departmentInfoEntity.state}, ${departmentInfoEntity.country}`}
                      </span>
                      <br />
                    </div>
                  </div>
                </Grid>
                <Grid size={12} className="container container-phrase">
                  <label htmlFor="message">Entity's Motto</label> <br />
                  <TextField
                    id="phrase"
                    name="phrase"
                    multiline
                    rows={4}
                    variant="outlined"
                    className="form-control"
                    value={departmentInfoEntity.phrase}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid size={12} className="container container-palette">
                  <label htmlFor="">App color scheme</label> <br />
                  <PaletteDropDown color={palette} onChange={handleThemeChange} />
                </Grid>
                <Grid size={12} className="container container-buttons">
                  <div className="save-button-container">
                    <ButtonSave
                      id="saveButton"
                      loading={posting}
                      onClickCallback={sendDepartmentInfo}
                      disabled={isReadOnlyMember}
                    />
                    <Button
                      style={{ maxWidth: '250px', minWidth: '250px' }}
                      variant="outlined"
                      id="cancelButtonEntity"
                      color="primary"
                      size="medium"
                      onClick={openConfirmationDialog}
                      disabled={isReadOnlyMember}
                    >
                      Discard
                    </Button>
                    {renderSavedMessage()}
                  </div>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </Container>
      )}
    </div>
  )
}

export default DepartmentInfo
